import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import PrimeVue from "primevue/config";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'primevue/resources/themes/saga-blue/theme.css'; // Theme
import 'primevue/resources/primevue.min.css'; // Core CSS
import 'primeicons/primeicons.css'; // Icons
import './assets/main.css'
import { createI18n } from 'vue-i18n'
import AnimateOnScroll from 'primevue/animateonscroll';
import Tooltip from 'primevue/tooltip';

const app = createApp(App);

import hu from './locale/hu.json'
import en from './locale/en.json'

const savedLocale = localStorage.getItem('locale') || 'hu'

const i18n = createI18n({
  legacy: false, 
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    hu: hu,
    en: en
  }
})

app.use(PrimeVue);
app.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 3,
  newestOnTop: true,
});
app.directive('animateonscroll', AnimateOnScroll);
app.directive('tooltip', Tooltip);
app.use(createPinia());
app.use(i18n)
app.use(router)
app.mount('#app');
